import {Fragment, observer, _, Popover2, React, Tooltip2, classNames} from '@api'
import {BuilderCardLoader, useAssortmentCardStore} from '@modules'
import * as css from './AssortmentCardHeader.css'
import {MyImage, PrimaryIconButton} from 'centric-ui-components'
import {HeaderPopoverContentPanel} from '.'
import {Tooltip} from '@material-ui/core'

export const AssortmentCardHeader = observer<{}, HTMLDivElement>(function AssortmentCardHeader(props, ref) {
  const {title, titleTooltip, attributes, dataMap, headerImageUrl, headerImageForeignKeyValue, strings} = useAssortmentCardStore()

  return (
    <div className={classNames(css.root, 'assortmentCardHeader')}>
      <div ref={ref}
           className={css.container}>
        <div className={css.title}
             data-field={dataMap.title?.field}
        >
          <Tooltip title={titleTooltip}>
            <span data-type='AssortmentHeaderTitleText' className={css.titleText}>{title}</span>
          </Tooltip>
        </div>
        <div className={css.imageAndAttributes}>
          {dataMap?.images && <div className={css.image}>
			  <Popover2
                // Supplier full popover image card in RH
				  interactionKind='hover'
				  position='left'
				  disabled={_.isString(dataMap?.images) || !dataMap?.images?.esIndex}
				  content={_.isString(dataMap?.images) || !headerImageForeignKeyValue ? null : <BuilderCardLoader isPopover esIndex={dataMap?.images?.esIndex} id={headerImageForeignKeyValue}/>}
			  >
				  <MyImage
					  imageUrl={headerImageUrl}
					  noImageContent={<span className={css.placeholderImage}/>}
				  />
			  </Popover2>
		  </div>}
          <div className={css.attributes}>
            {attributes.map(({field, label, value}, i) =>
              <div className={css.attribute} data-field={field.field} key={i}>
                <span className={css.label}>{label}:</span>
                <span className={css.value}>{(_.isArray(value) ? value.join(', ') : value === strings.noValue ? '' : value) || ''}</span>
              </div>)}
          </div>
        </div>
      </div>
    </div>)
}, {forwardRef: true})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/Header/AssortmentCardHeader.tsx